/**
 * Kompenzácia fyzicky portrait/landscape-mountovanej obrazovky, ktorej OS/prehliadač
 * nevie natívne rotovať (hlási stále rovnaké – nesprávne – rozmery viewportu).
 *
 * Vyrenderuje aktuálnu obrazovku do <iframe> so zámerne PREHODENÝMI pixelovými
 * rozmermi (šírka/výška), a celý iframe otočí cez CSS transform. Keďže iframe má
 * VLASTNÝ nezávislý viewport, všetky vw/vh jednotky vnútri šablóny (fonty, výšky
 * obrázkov cez clamp()) sa počítajú správne voči "otočeným" rozmerom – presne ako
 * na natívne správne orientovanej obrazovke.
 *
 * src iframe = aktuálna URL + príznak __rotated=1, aby si vnútorný Router NEZAČAL
 * kontrolovať rotáciu znova (zabránenie nekonečnému vnáraniu iframe do iframe).
 */
import React, { useEffect, useMemo, useState } from "react";

function buildIframeSrc() {
  const url = new URL(window.location.href);
  url.searchParams.set("__rotated", "1");
  return url.toString();
}

export default function RotatedIframeScreen({ rotation }) {
  const [viewport, setViewport] = useState(() => ({
    width: window.innerWidth,
    height: window.innerHeight,
  }));

  useEffect(() => {
    const onResize = () =>
      setViewport({ width: window.innerWidth, height: window.innerHeight });
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  const iframeSrc = useMemo(() => buildIframeSrc(), []);

  // Vymenené rozmery – iframe dostane rozmery zodpovedajúce "logicky" správnej
  // (neotočenej) obrazovke, aby jej vlastný viewport (a teda vw/vh) sedel s dizajnom.
  const swappedWidth = viewport.height;
  const swappedHeight = viewport.width;

  const transform =
    rotation === "ccw"
      ? "rotate(-90deg) translateX(-100%)"
      : "rotate(90deg) translateY(-100%)";

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        overflow: "hidden",
        background: "#000",
        margin: 0,
      }}
    >
      <iframe
        key={iframeSrc}
        title="daily-menu-rotated"
        src={iframeSrc}
        width={swappedWidth}
        height={swappedHeight}
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          border: "none",
          transformOrigin: "top left",
          transform,
        }}
      />
    </div>
  );
}
